import "core-js/modules/es.array.push.js";
import SubMenu from './SubMenu';
import { getHomeMenu, getProductUse } from '@/api/modules/personal.js';
export default {
  name: 'nav-menu',
  components: {
    SubMenu
  },
  props: {
    scrollTop: {
      type: Number,
      default: 0
    },
    changeBg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuList: [],
      productMenu: [],
      subMenuShowIndex: -1,
      darkRouteNameArray: ['404', 'agreement']
    };
  },
  async created() {
    let {
      result
    } = await getProductUse();
    result.forEach(ol => {
      let obj = {};
      obj['value'] = ol.name;
      obj['label'] = ol.name;
      obj['code'] = ol.code;
      obj['disabled'] = false;
      this.productMenu.push(obj);
    });
    getHomeMenu().then(res => {
      this.menuList = res.result;
      this.menuList.forEach(item => {
        if (item.menu_name === '产品试用') {
          item.children = result;
        }
      });
    });
  },
  computed: {
    subMenuStyle() {
      return index => {
        if (index === 1) {
          return {
            left: '-160px'
          };
        }
        return {
          left: '0'
        };
      };
    },
    routeName() {
      return this.$route.name;
    }
  },
  methods: {
    handleMouseenter(index) {
      this.subMenuShowIndex = index;
    },
    handleMouseleave() {
      this.subMenuShowIndex = -1;
    },
    handleMenuClick(menuItem) {
      if (!menuItem.disabled && !menuItem.children.length) {
        this.$router.push({
          path: menuItem.path
        });
      }
    }
  }
};